import './base/'

const $win = $(window);
const $doc = $(document);

// Your code goes here...
// jQuery.ready is no longer needed



// WEBPACK FOOTER //
// ./../src/assets/js/main.js